import { useState, useEffect } from "react";
import { css } from "@emotion/react";
import YouTube from "react-youtube";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import { useGetMediaSize, useIsPC } from "../../hooks";
import { fadeInVariants } from "../../constants/animations";

const videos = [
  {
    id: 1,
    title: "ロング予告",
    videoId: "0135ru2HfuU",
    img: "longyokoku.png",
  },
  {
    id: 2,
    title: "30秒予告",
    videoId: "LfRvHiOgcyg",
    img: "30minyokoku.png",
  },
  {
    id: 3,
    title: "特報",
    videoId: "X4l-Da7ofoU",
    img: "tokuhou.png",
  },
  {
    id: 4,
    title: "キャラクター紹介動画",
    videoId: "F2hWo1H4xuU",
    img: "character-syokai.png",
  },
  {
    id: 5,
    title: "解説動画",
    videoId: "SXUvmCpoGk0",
    img: "kaisetsu-movie.png",
  },
  {
    id: 6,
    title: "本編映像1",
    videoId: "xP5yn8b0Ocg",
    img: "honpen1.png",
  },
  {
    id: 7,
    title: "本編映像2",
    videoId: "GfpdJsvzCMI",
    img: "honpen2.png",
  },
  {
    id: 8,
    title: "本編映像3",
    videoId: "uvQLHvSVCsQ",
    img: "honpen3.png",
  },
];

const Trailer = () => {
  const [selectedVideo, setSelectedVideo] = useState(videos[0].videoId);

  const isPC = useIsPC();
  const { width, height } = useGetMediaSize({});
  const controls = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView]);

  return (
    <motion.div
      css={mainStyle}
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={fadeInVariants}
      id="trailer"
    >
      <div css={titleStyle}>TRAILER</div>
      <div css={containerStyle}>
        <YouTube videoId={selectedVideo} opts={{ width, height }} />
        <div css={videoContainerStyle}></div>
        <div css={buttonContainerStyle(isPC ? (width * 3) / 5 : width)}>
          {videos.map((video) => (
            <button
              key={video.id}
              onClick={() => setSelectedVideo(video.videoId)}
              css={buttonStyle}
            >
              <img
                src={process.env.REACT_APP_BASE_PATH + `/img/${video.img}`}
                alt={video.title}
                css={btnImgStyle}
              />
            </button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

const spSize = 768;

const mainStyle = css`
  position: relative;
  width: 100%;
  padding: 40px 0 60px;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${spSize}px) {
    padding: 30px 0 40px;
  }
`;

const titleStyle = css`
  font-size: 35px;
  font-weight: 500;
  letter-spacing: 0.075em;

  @media (max-width: ${spSize}px) {
    font-size: 20px;
    font-weight: 400;
  }
`;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const videoContainerStyle = css`
  margin-bottom: 20px;
`;

const buttonContainerStyle = (width: number) => css`
  width: ${width}px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
`;

const buttonStyle = css`
  background-color: transparent;
  border: 0px;
  padding: 0;
  cursor: pointer;
`;

const btnImgStyle = css`
  width: 100%;
  height: auto;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #052733;
  }
`;

export default Trailer;
